import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Subtitle1 } from '@src/elements/typography/typography'

@Component
export class ListCell extends Vue {
  @Prop({ required: true })
  item: any

  @Prop({ required: false })
  name: string

  @Prop({ required: false })
  itemIndex: number
}

@Component
export class TextCell extends ListCell {

  render (h: CreateElement) {
    return <Subtitle1 class='cell text-cell'>{this.item[this.name]}</Subtitle1>
  }

}
